import { useDispatch, useSelector } from 'react-redux';
import { getMerchantUsers, deleteMerchantUser, cleanError, inviteUser, updateUserRole, swapOwnerRole } from './actions';
import { UserManagementSelectors } from './selectors';

export const useUserManagement = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(UserManagementSelectors.getLoading),
    error: useSelector(UserManagementSelectors.getError),
    errorInfo: useSelector(UserManagementSelectors.getErrorInfo),
    allMerchantUsers: useSelector(UserManagementSelectors.getAllMerchantUsers),
    deleteSuccess: useSelector(UserManagementSelectors.getDeleteSuccess),
    swapOwnerSuccess: useSelector(UserManagementSelectors.getSwapOwnerSuccess),
    inviteLoading: useSelector(UserManagementSelectors.getInviteLoading),
    inviteError: useSelector(UserManagementSelectors.getInviteError),
    inviteErrorInfo: useSelector(UserManagementSelectors.getInviteErrorInfo),
    getMerchantUsers: (page?: number, pageSize?: number, filters?: { email?: string; name?: string }) =>
      dispatch(getMerchantUsers(page, pageSize, filters)),
    deleteMerchantUser: (merchantUserId: number) => dispatch(deleteMerchantUser(merchantUserId)),
    updateUserRole: (userId: number, role: string) => dispatch(updateUserRole(userId, role)),
    swapOwnerMerchantUser: (merchantUserId: number) => dispatch(swapOwnerRole(merchantUserId)),
    cleanError: () => dispatch(cleanError()),
    inviteUser: (fullName: string, email: string, role: string) => dispatch(inviteUser({ fullName, email, role })),
  };
};
